var _defs, _rect, _rect2, _rect3, _circle, _circle2, _circle3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path, _path2, _path3, _path4, _path5, _path6, _circle4, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIlluSpreadsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "illu_spreadsheet",
    "data-name": "illu spreadsheet",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 976.62 641.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e6e6e6;}.cls-2{fill:#fff;}.cls-3{fill:#4b55f6;}.cls-4{fill:#3f3d56;}.cls-5{fill:#2f2e41;}.cls-6{fill:#ffb9b9;}.cls-7{fill:#575a89;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2647",
    "data-name": "Rectangle 2647",
    className: "cls-1",
    x: 331.9,
    y: 0.37,
    width: 644.72,
    height: 412.91
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2648",
    "data-name": "Rectangle 2648",
    className: "cls-2",
    x: 350.33,
    y: 52.15,
    width: 607.85,
    height: 336.69
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2649",
    "data-name": "Rectangle 2649",
    className: "cls-3",
    x: 331.62,
    width: 644.72,
    height: 27.39
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1366",
    "data-name": "Ellipse 1366",
    className: "cls-2",
    cx: 351.98,
    cy: 14,
    r: 5.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1367",
    "data-name": "Ellipse 1367",
    className: "cls-2",
    cx: 371.25,
    cy: 14,
    r: 5.08
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1368",
    "data-name": "Ellipse 1368",
    className: "cls-2",
    cx: 390.52,
    cy: 14,
    r: 5.08
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2650",
    "data-name": "Rectangle 2650",
    className: "cls-1",
    x: 410.57,
    y: 109.07,
    width: 61,
    height: 27
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2651",
    "data-name": "Rectangle 2651",
    className: "cls-1",
    x: 532.57,
    y: 165.07,
    width: 61,
    height: 27
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2652",
    "data-name": "Rectangle 2652",
    className: "cls-3",
    x: 410.57,
    y: 249.07,
    width: 61,
    height: 27
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2653",
    "data-name": "Rectangle 2653",
    className: "cls-3",
    x: 532.57,
    y: 305.07,
    width: 61,
    height: 27
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2654",
    "data-name": "Rectangle 2654",
    className: "cls-3",
    x: 836.57,
    y: 333.07,
    width: 61,
    height: 27
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2655",
    "data-name": "Rectangle 2655",
    className: "cls-1",
    x: 775.57,
    y: 221.07,
    width: 61,
    height: 27
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2656",
    "data-name": "Rectangle 2656",
    className: "cls-3",
    x: 593.57,
    y: 221.07,
    width: 122,
    height: 27
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2657",
    "data-name": "Rectangle 2657",
    className: "cls-3",
    x: 593.57,
    y: 80.07,
    width: 122,
    height: 27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_4939",
    "data-name": "Path 4939",
    className: "cls-1",
    d: "M349.57,51.07v339h610v-339Zm608,28.08h-58.8V53.07h58.8ZM594.77,275.73V249.65h119.6v26.08Zm119.6,2v26.09H594.77V277.73Zm0-112.33v26.08H594.77V165.4Zm-119.6-2V137.32h119.6V163.4Zm0,56.17V193.48h119.6v26.09Zm119.6,2v26.08H594.77V221.57Zm-121.6-30.09H534V165.4h58.8Zm0,2v26.09H534V193.48Zm0,28.09v26.08H534V221.57Zm0,28.08v26.08H534V249.65Zm123.6,0h58.8v26.08h-58.8Zm0-2V221.57h58.8v26.08Zm0-28.08V193.48h58.8v26.09Zm0-28.09V165.4h58.8v26.08Zm0-28.08V137.32h58.8V163.4Zm0-28.08V109.23h58.8v26.09Zm-2,0H594.77V109.23h119.6Zm-121.6,0H534V109.23h58.8Zm0,2V163.4H534V137.32ZM532,163.4h-58.8V137.32H532Zm0,2v26.08h-58.8V165.4Zm0,28.08v26.09h-58.8V193.48Zm0,28.09v26.08h-58.8V221.57Zm0,28.08v26.08h-58.8V249.65Zm0,28.08v26.09h-58.8V277.73Zm2,0h58.8v26.09H534Zm58.8,28.09V331.9H534V305.82Zm2,0h119.6V331.9H594.77Zm121.6,0h58.8V331.9h-58.8Zm0-2V277.73h58.8v26.09Zm60.8-26.09H836v26.09h-58.8Zm0-2V249.65H836v26.08Zm0-28.08V221.57H836v26.08Zm0-28.08V193.48H836v26.09Zm0-28.09V165.4H836v26.08Zm0-28.08V137.32H836V163.4Zm0-28.08V109.23H836v26.09Zm0-28.09V81.15H836v26.08Zm-2,0h-58.8V81.15h58.8Zm-60.8,0H594.77V81.15h119.6Zm-121.6,0H534V81.15h58.8Zm-60.8,0h-58.8V81.15H532Zm0,2v26.09h-58.8V109.23Zm-60.8,26.09h-58.8V109.23h58.8Zm0,2V163.4h-58.8V137.32Zm0,28.08v26.08h-58.8V165.4Zm0,28.08v26.09h-58.8V193.48Zm0,28.09v26.08h-58.8V221.57Zm0,28.08v26.08h-58.8V249.65Zm0,28.08v26.09h-58.8V277.73Zm0,28.09V331.9h-58.8V305.82Zm2,0H532V331.9h-58.8ZM532,333.9V360h-58.8V333.9Zm2,0h58.8V360H534Zm60.8,0h119.6V360H594.77Zm121.6,0h58.8V360h-58.8Zm60.8,0H836V360h-58.8Zm0-2V305.82H836V331.9ZM838,305.82h58.8V331.9H838Zm0-2V277.73h58.8v26.09Zm0-28.09V249.65h58.8v26.08Zm0-28.08V221.57h58.8v26.08Zm0-28.08V193.48h58.8v26.09Zm0-28.09V165.4h58.8v26.08Zm0-28.08V137.32h58.8V163.4Zm0-28.08V109.23h58.8v26.09Zm0-28.09V81.15h58.8v26.08Zm0-28.08V53.07h58.8V79.15Zm-2,0h-58.8V53.07H836Zm-60.8,0h-58.8V53.07h58.8Zm-60.8,0H594.77V53.07h119.6Zm-121.6,0H534V53.07h58.8Zm-60.8,0h-58.8V53.07H532Zm-60.8,0h-58.8V53.07h58.8Zm0,2v26.08h-58.8V81.15Zm-60.8,26.08h-58.8V81.15h58.8Zm0,2v26.09h-58.8V109.23Zm0,28.09V163.4h-58.8V137.32Zm0,28.08v26.08h-58.8V165.4Zm0,28.08v26.09h-58.8V193.48Zm0,28.09v26.08h-58.8V221.57Zm0,28.08v26.08h-58.8V249.65Zm0,28.08v26.09h-58.8V277.73Zm0,28.09V331.9h-58.8V305.82Zm0,28.08V360h-58.8V333.9Zm2,0h58.8V360h-58.8ZM471.17,362v26.09h-58.8V362Zm2,0H532v26.09h-58.8Zm60.8,0h58.8v26.09H534Zm60.8,0h119.6v26.09H594.77Zm121.6,0h58.8v26.09h-58.8Zm60.8,0H836v26.09h-58.8Zm60.8,0h58.8v26.09H838Zm0-2V333.9h58.8V360Zm60.8-26.08h58.8V360h-58.8Zm0-2V305.82h58.8V331.9Zm0-28.08V277.73h58.8v26.09Zm0-28.09V249.65h58.8v26.08Zm0-28.08V221.57h58.8v26.08Zm0-28.08V193.48h58.8v26.09Zm0-28.09V165.4h58.8v26.08Zm0-28.08V137.32h58.8V163.4Zm0-28.08V109.23h58.8v26.09Zm0-28.09V81.15h58.8v26.08ZM410.37,53.07V79.15h-58.8V53.07ZM351.57,362h58.8v26.09h-58.8Zm547.2,26.09V362h58.8v26.09Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4940",
    "data-name": "Path 4940",
    className: "cls-4",
    d: "M257.74,637.66H0v-2.11H258.12Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4941",
    "data-name": "Path 4941",
    className: "cls-5",
    d: "M190.43,339.73l-6.69,158-4.18,71.06s9.2,15.05-4.18,16.72-38.45-2.51-35.11-10.87,5.85-8.36,5.85-8.36L149.46,486l-25.08-98.65L92.61,493.56l-6.69,76.07s9.2,11.7,0,14.22-33.44,2.5-32.6-5,4.18-7.52,4.18-7.52L53.32,350.59l12.54-19.22Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4942",
    "data-name": "Path 4942",
    className: "cls-5",
    d: "M172,580.5l3.34,20.9s19.23,40.13-7.52,40.13-19.23-15.88-19.23-15.88l2.51-45.15Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4943",
    "data-name": "Path 4943",
    className: "cls-5",
    d: "M58.34,580.5,55,601.4s-19.23,40.13,7.53,40.13,19.23-15.88,19.23-15.88L79.24,580.5Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4944",
    "data-name": "Path 4944",
    className: "cls-6",
    d: "M143.61,103.13s8.36,30.1,10,30.1-15.88,23.41-15.88,23.41l-25.92,14.21-9.2-38.45s8.36-20.9,6.69-31.77Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1369",
    "data-name": "Ellipse 1369",
    className: "cls-6",
    cx: 130.24,
    cy: 83.9,
    r: 30.93
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4945",
    "data-name": "Path 4945",
    className: "cls-7",
    d: "M126.06,148.28l24.71-21.47,14.58,7.25,31.77,20.07s-8.36,180.58-4.18,187.27c0,0-9.2,20.9-63.54,8.36s-68.55-14.21-68.55-14.21l11.7-110.36L58.33,155.8l47.74-33.38,15,25.86Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4946",
    "data-name": "Path 4946",
    className: "cls-6",
    d: "M44.13,211.82,36.6,246.93V318s10.87,45.14,19.23,33.44S64,336,64,336l-10.7-16.36,5-66.88,13.32-31.9Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4947",
    "data-name": "Path 4947",
    className: "cls-6",
    d: "M184,230.49l8.88,35-4.11,70.32L176,351.42s-.68,3.84,6,17.12,23.61-32.35,23.61-32.35l9.66-74-2.69-37.56Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4948",
    "data-name": "Path 4948",
    className: "cls-5",
    d: "M101,53s10-21.74,29.26-16.72,30.1,12.53,30.93,20.06-.42,18.81-.42,18.81S158.66,59.66,145.29,63s-34.28.84-34.28.84l-3.34,30.1s-3.77-5.44-8-2.09S87.6,59.66,101,53Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4949",
    "data-name": "Path 4949",
    className: "cls-7",
    d: "M77.57,154.13,58.34,155.8s-21.74,59.36-19.23,61,32.6,11.7,36.78,9.2S77.57,154.13,77.57,154.13Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_4950",
    "data-name": "Path 4950",
    className: "cls-7",
    d: "M190.43,155.8l6.69-1.67s12.54,15.88,16.72,34.28,10,36.78,6.69,36.78-43.8,10.88-43.8,10.88Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlluSpreadsheet);
export default __webpack_public_path__ + "static/media/illu-spreadsheet.39b5d03720085749ac98b7668451ea4e.svg";
export { ForwardRef as ReactComponent };